export enum ContentPageId {
  accounttriage = 'accounttriage',
  assumeinherit = 'assumeinherit',
  benedetails = 'benedetails',
  benerelationship = 'benerelationship',
  cancel = 'cancel',
  clientduediligence = 'clientduediligence',
  confirm = 'confirm',
  contactinfo = 'contactinfo',
  daoffer = 'daoffer',
  dateofbirth = 'dateofbirth',
  dateofdeath = 'dateofdeath',
  decedent = 'decedent',
  decedentid = 'decedentid',
  documentupload = 'documentupload',
  letterupload = 'letterupload',
  employment = 'employment',
  error = 'error',
  estate = 'estate',
  giftingassets = 'giftingassets',
  giftingadvised = 'giftingadvised',
  giftingcommon = 'giftingcommon',
  giftingconfirm = 'giftingconfirm',
  giftingintelledoxredirect = 'giftingintelledoxredirect',
  giftingmethod = 'giftingmethod',
  giftingoverview = 'giftingoverview',
  giftingrecipient = 'giftingrecipient',
  giftingrecipienttriage = 'giftingrecipienttriage',
  giftingsummary = 'giftingsummary',
  giftingtriage = 'giftingtriage',
  giftingreview = 'giftingreview',
  guide = 'guide',
  incomenetworth = 'incomenetworth',
  ineligible = 'ineligible',
  inheritanceoverview = 'inheritanceoverview',
  internaltransferamounts = 'internaltransferamounts',
  internaltransferconfirm = 'internaltransferconfirm',
  internaltransfercostbasiselection = 'internaltransfercostbasiselection',
  internaltransferexpired = 'internaltransferexpired',
  internaltransferfromto = 'internaltransferfromto',
  internaltransferdetails = 'internaltransferdetails',
  internaltransferholdingsreview = 'internaltransferholdingsreview',
  internaltransfermultireview = 'internaltransfermultireview',
  internaltransferoverview = 'internaltransferoverview',
  internaltransfersummary = 'internaltransfersummary',
  internaltransfersummarymulti = 'internaltransfersummarymulti',
  internaltransfertriage = 'internaltransfertriage',
  internaltransfertriagemulti = 'internaltransfertriagemulti',
  investmentobjectives = 'investmentobjectives',
  investmentstrategy = 'investmentstrategy',
  inheritediratriage = 'inheritediratriage',
  iratype = 'iratype',
  minoroverview = 'minoroverview',
  multiaccountenrollemnt = 'multiaccountenrollment',
  namecomponent = 'namecomponent',
  newaccountreview = 'newaccountreview',
  personalinfo = 'personalinfo',
  receipt = 'receipt',
  review = 'review',
  riskquizsetup = 'riskquizsetup',
  samplePageId = 'samplePageId',
  shared = 'shared',
  tcftrustsign = 'tcftrustsign',
  termsexisting = 'termsexisting',
  termsnew = 'termsnew',
  termsgifting = 'termsgifting',
  testmonkey = 'testmonkey',
  transferfrom = 'transferfrom',
  transferto = 'transferto',
  triage = 'triage',
  triagesummary = 'triagesummary',
  trustinfo = 'trustinfo',
  trusttaxinfo = 'trusttaxinfo',
  trusttriage = 'trusttriage',
  trusttotrustinfo = 'trusttotrustinfo',
  unittest = 'unittest',
  zipcode = 'zipcode',
  settlementfund = 'settlementfund',
  multitriage = 'multitriage',
  multitrusttriage = 'multitrusttriage',
  multitermsnew = 'multitermsnew',
  openchoice = 'openchoice',
  multitermsbase = 'multitermsbase',
  reviewsign = 'reviewsign',
}
